import { render, staticRenderFns } from "./SessionList.vue?vue&type=template&id=678d3184&"
import script from "./SessionList.vue?vue&type=script&lang=ts&"
export * from "./SessionList.vue?vue&type=script&lang=ts&"
import style0 from "./SessionList.vue?vue&type=style&index=0&id=678d3184&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports